import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Collapse } from "@mui/material";
import { ExpandMore, ChevronRight, Folder, Link as LinkIcon } from "@mui/icons-material";
import api from "../services/api/api";

const MapaDoSite = () => {
  const [openPrefeitura, setOpenPrefeitura] = useState(false);
  const [openACamara, setOpenACamara] = useState(false);
  const [openPublicacoes, setOpenPublicacoes] = useState(false);
  const [publicacoesItens, setPublicacoesItens] = useState([]);

  const togglePrefeitura = () => setOpenPrefeitura((prev) => !prev);
  const toggleMunicipio = () => setOpenACamara((prev) => !prev);
  const togglePublicacoes = () => setOpenPublicacoes(!openPublicacoes);

  const fetchPublicacoesCategorias = async () => {
    try {
      const response = await api.get("api/categories");
      if (response.data) {
        const categorias = response.data.map((categoria) => ({
          label: categoria.name,
          to: `/publicacoes/${categoria.name}`,
        }));
        setPublicacoesItens(categorias);
      }
    } catch (error) {
      console.error("Erro ao buscar categorias de publicações:", error.message);
    }
  };

  useEffect(() => {
    fetchPublicacoesCategorias();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f0f0f0",
      }}
    >
      <Box
        sx={{
          padding: 4,
          width: "90%",
          maxWidth: 600,
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: 2, textAlign: "center" }}>
          Mapa do Site
        </Typography>
        <Box>
          <Button
            startIcon={openPrefeitura ? <ExpandMore /> : <ChevronRight />}
            onClick={togglePrefeitura}
            fullWidth
            sx={{ justifyContent: "flex-start", fontWeight: "bold", textTransform: "none", marginBottom: 1 }}
          >
            <Folder sx={{ marginRight: 1 }} /> A CÂMARA
          </Button>
          <Collapse in={openPrefeitura}>
            <Box sx={{ marginLeft: 4 }}>
              <Button href="/mesadiretora" startIcon={<LinkIcon />} sx={{ justifyContent: "flex-start", textTransform: "none", width: "100%" }}>
                MESA DIRETORA ↗
              </Button>
              <Button href="/institucional" startIcon={<LinkIcon />} sx={{ justifyContent: "flex-start", textTransform: "none", width: "100%" }}>
                INSTITUCIONAL ↗
              </Button>
            </Box>
          </Collapse>
        </Box>
        <Box>
          <Button href="/noticias" fullWidth sx={{ justifyContent: "flex-start", fontWeight: "bold", textTransform: "none", marginBottom: 1 }}>
            <Folder sx={{ marginRight: 1 }} /> NOTÍCIAS ↗
          </Button>
        </Box>
        <Box>
          <Button href="/transparencia" fullWidth sx={{ justifyContent: "flex-start", fontWeight: "bold", textTransform: "none", marginBottom: 1 }}>
            <Folder sx={{ marginRight: 1 }} /> PORTAL DA TRANSPARÊNCIA ↗
          </Button>
        </Box>
        <Box>
          <Button startIcon={openPublicacoes ? <ExpandMore /> : <ChevronRight />} onClick={togglePublicacoes} fullWidth sx={{ justifyContent: "flex-start", fontWeight: "bold", textTransform: "none", marginBottom: 1 }}>
            <Folder sx={{ marginRight: 1 }} /> PUBLICAÇÕES
          </Button>
          <Collapse in={openPublicacoes}>
            <Box sx={{ marginLeft: 4 }}>
              {publicacoesItens.length > 0 ? (
                publicacoesItens.map((item) => (
                  <Button key={item.to} startIcon={<LinkIcon />} sx={{ justifyContent: "flex-start", textTransform: "none", width: "100%", marginBottom: 1 }} onClick={() => (window.location.href = item.to)}>
                    {item.label}
                  </Button>
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  Nenhuma publicação disponível.
                </Typography>
              )}
            </Box>
          </Collapse>
        </Box>
      </Box>
    </Box>
  );
};

export default MapaDoSite;
